import { defineComponent as _defineComponent } from 'vue'
import EventsTableExpandedView from '@/components/careConsole/EventsTableExpandedView.vue';
import WidgetDefinition, {
  ParamValues,
} from '@/models/Charts/widgetDefinition';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWrappedEventsTableExpandedView',
  props: {
    widgetDefinition: null,
    selectedDeviceIds: null,
    selectedTimeFilter: null,
    selectedDateGrouping: null,
    routeParams: null,
    paramValues: { default: () => ({}) },
    module: null,
    timestamp: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {





return { __sfc: true,emit, EventsTableExpandedView }
}

})